export default {
  step1: '基本情報',
  step2: 'スペック/価格情報',
  step3: 'ギフト詳細',
  giftName: 'ギフト名',
  giftNameRequired: 'ギフト名を入力してください',
  giftNamePlaceholder: 'ギフト名を入力してください',
  giftType: 'ギフトタイプ',
  giftTypeRequired: 'ギフトタイプを選択してください',
  giftTypeTip: 'ギフトタイプ：実物ギフト、バーチャルギフト',
  physicalGift: '実物ギフト',
  virtualGift: 'バーチャルギフト',
  giftCategory: 'ギフトカテゴリ',
  giftNo: 'ギフトコード',
  giftNoRequired: 'ギフトコードを入力してください',
  giftNoPlaceholder: 'ギフトコードを入力してください',
  giftImage: 'ギフト画像',
  imageRequired: 'ギフト画像をアップロードしてください',
  giftValue: 'ギフト価値',
  valuePlaceholder: 'ギフト価値を入力してください',
  productSpec: '製品スペック',
  singleSpec: '単一スペック',
  multiSpec: '複数スペック',
  specNamePlaceholder: 'スペック名',
  addSpecValue: '追加',
  addSpecGroup: '+ スペック追加',
  generateSpecs: '+ スペック生成',
  specImage: 'スペック画像',
  specPrice: '価格（元）',
  specStock: '在庫',
  specNo: 'スペック番号',
  specNoPlaceholder: 'スペック番号を入力してください',
  specImageRequired: '仕様画像は必須です',
  specMatrixRequired: '仕様マトリックスを先に生成してください',
  stockPlaceholder: '入力してください',
  editSpecName: 'スペック名を変更',
  select: '選択',
  giftDetail: '商品詳細',
  detailPlaceholder: '本文を入力してください',
  phonePreview: '商品詳細',
  applySpecChanges: '変更を確定',
};
